import { queryOptions } from '@tanstack/react-query';

import { apiSigningFetch } from '..';
import { AgreementDocument, TemplateField } from './types';

export const SIGNING_QUERY_KEY = {
  document: 'document',
  referral: 'referral',
  filters: 'filters',
  templateFields: 'template-fields',
};

export const _getDocumentById = (id: string | undefined) => {
  return queryOptions({
    queryKey: [SIGNING_QUERY_KEY.document, id],
    queryFn: () => apiSigningFetch<AgreementDocument>(`/documents/${id}`),
    retry: 0,
  });
};

export const _getTemplateFields = (templateId?: number) => {
  return queryOptions({
    queryKey: [SIGNING_QUERY_KEY.templateFields, templateId],
    queryFn: () => apiSigningFetch<TemplateField[]>(`/documents/templates/${templateId}/fields`),
    enabled: templateId != null,
    retry: 0,
  });
};
